import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store } from "@/store";
import * as Sentry from "@sentry/capacitor";
import * as SentryVue from "@sentry/vue";
import ClarityPlugin from './plugins/clarity.plugin';

import { IonicVue } from '@ionic/vue';

import { defineCustomElements } from '@ionic/pwa-elements/loader';
/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './assets/scss/main.scss';

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init(
    {
      dsn: process.env.VUE_APP_SENTRY_DSN,
      environment: process.env.NODE_ENV || 'development',
      integrations: [
        new SentryVue.BrowserTracing({
          routingInstrumentation: SentryVue.vueRouterInstrumentation(router),
        }),
        new SentryVue.Replay(),
      ],
      tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    },
    SentryVue.init
  );
}

const app = createApp(App)
    .use(IonicVue)
    .use(router)
    .use(store)

if (process.env.VUE_APP_CLARITY_PROJECT_ID) {
    app.use(ClarityPlugin, {
        projectId: process.env.VUE_APP_CLARITY_PROJECT_ID,
        store: store,
        consent: {
            ad_Storage: 'granted',
            analytics_Storage: 'granted'
        }
    });
}

router.isReady().then(() => {
  app.mount('#app');
});

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window).then();